<template>
  <div class="xcard">
    <v-btn small class="mx-0" @click="$router.back()" color="info" tile outlined>
      <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn
    >
    <h4 class="text-primary text-center">HABILITACIÓN PARA ENTREGA DE PROYECTOS</h4>
    <p class="ma-0">Responsable DNA - ESAM: EGBERTO BURGOS ERAZO</p>

    <v-row>
      <v-col sm="3">
        <label>MES DE RECEPCIÓN DE PROYECTOS</label>
        <v-select dense outlined :items="meses" item-text="mes" return-object></v-select>
      </v-col>
      <v-col sm="3">
        <label>GESTIÓN DE RECEPCIÓN DE PROYECTOS</label>
        <v-select dense outlined :items="gestiones" item-text="gestion" return-object></v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <label>CÓDIGO ACADÉMICO DIPLOMADOS</label>
        <v-text-field dense outlined></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <label>CÓDIGO ACADÉMICO ESPECIALIDADES</label>
        <v-text-field dense outlined></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col sm="3">
        <label>CÓDIGO ACADÉMICO MAESTRÍAS</label>
        <v-text-field dense outlined></v-text-field>
      </v-col>
    </v-row>

    <v-btn class="green mr-4" dark>Habilitar</v-btn>
    <v-btn class="orange" dark>Cancelar</v-btn>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        meses: [
          { id: 0, mes: 'Enero' },
          { id: 1, mes: 'Febrero' },
          { id: 2, mes: 'Marzo' },
          { id: 3, mes: 'Abril' },
          { id: 4, mes: 'Mayo' },
          { id: 5, mes: 'Junio' },
          { id: 6, mes: 'Julio' },
          { id: 7, mes: 'Agosto' },
          { id: 8, mes: 'Septiembre' },
          { id: 9, mes: 'Octubrre' },
          { id: 10, mes: 'Noviembre' },
          { id: 11, mes: 'Diciembre' },
        ],
        gestiones: [],
      };
    },
    methods: {
      creargestiones() {
        let este = new Date().getFullYear();
        let inicio = 2019;
        let i = este - inicio;
        for (let k = 0; k <= i; k++) {
          this.gestiones.push({ gestion: inicio + k });
        }
      },
    },
    mounted() {
      this.creargestiones();
    },
  };
</script>
